import { CircularProgress } from "@mui/material";
import * as React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useAuthContext } from "./AuthContext";
import Footer from "./components/_Misc/Footer";

interface PrivateRouteProps extends RouteProps {
  component: any;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, ...rest } = props;
  // const [authInfo, setAuthInfo] = React.useState(null as null | AuthInfo);
  // const [error, setError] = React.useState(null as null | string);
  const authInfo = useAuthContext();
  const isAuthedMember = authInfo.authed && authInfo.is_member;

  const isMobile: boolean = window.innerWidth <= 768;
  const h = window.innerHeight;
  let minHeight = "74vh";
  if (isMobile) {
    minHeight = h > 950 ? "79vh" : h > 900 ? "77vh" : h > 700 ? "65vh" : "54vh";
  } else {
    minHeight = h > 950 ? "73vh" : h > 900 ? "73vh" : h > 700 ? "71vh" : h > 600 ? "69vh" : h > 500 ? "77vh" : "59vh";
  }

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isAuthedMember ? (
          <>
            {/* <span style={{ position: "absolute" }}>{minHeight}</span> */}
            <div
              style={{
                minHeight: minHeight,
                position: "relative",
              }}
            >
              <Component {...routeProps} />
            </div>
            <Footer />
          </>
        ) : authInfo ? (
          <Redirect
            to={{
              pathname: "/login",
              state: { PREVIOUS_PATH: routeProps.location.pathname },
            }}
          />
        ) : (
          // <div style={{ display: 'flex', justifyContent: 'center' }}>Route Loading...</div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress color="secondary" />
          </div>
        )
      }
    />
  );
};

export default PrivateRoute;
